import { Controller } from "@hotwired/stimulus"
import { currentOrigin, fromParam, recallOrigin, rememberOrigin, stripFrom } from "../helpers/return_origin"

export default class extends Controller {
  connect() {
    this.applyClientState()
    this.boundReapplyAfterMorph = this.applyClientState.bind(this)
    document.addEventListener("turbo:morph", this.boundReapplyAfterMorph)
  }

  disconnect() {
    if (this.boundReapplyAfterMorph) document.removeEventListener("turbo:morph", this.boundReapplyAfterMorph)
  }

  applyClientState() {
    const here = stripFrom(currentOrigin())
    rememberOrigin(here, fromParam(currentOrigin()))

    const href = this.element.getAttribute("href")
    if (!href || fromParam(href)) return

    const origin = recallOrigin(href)
    if (!origin || stripFrom(origin) === here) return

    const separator = href.includes("?") ? "&" : "?"
    this.element.setAttribute("href", `${href}${separator}from=${encodeURIComponent(origin)}`)
  }
}
